import styled from 'styled-components';

const Card = styled.div`
  align-items: center;
  background: var(--color-bg-default);
  border: 1px solid var(--color-border-default);
  border-radius: var(--size-border-radius-md);
  display: flex;
  flex-direction: column;
  padding: var(--size-padding-40);
`;

const ContinueLoginContainer = styled.div`
  align-items: flex-start;
  display: flex;
  height: 100%;
`;

export { Card, ContinueLoginContainer };
